export const FETCH_CLIENT = 'FETCH_CLIENT';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_CONDITIONS_SURVEYS = 'FETCH_CONDITIONS_SURVEYS';
export const FETCH_ORGANIZATION = 'FETCH_ORGANIZATION';
export const FETCH_CLIENT_ORGANIZATION = 'FETCH_CLIENT_ORGANIZATION';
export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
export const FETCH_USER_INVITATIONS = 'FETCH_USER_INVITATIONS';